import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class IntroService {

    constructor(public af: AngularFireDatabase, private loadingService: LoadingService) {}

    // Set data for - WIZARD MAIN
    getData = (): any => {
        return {
          'btnPrev': 'Previous',
          'btnNext': 'Next',
          'btnFinish': 'Finish',
          'icon': 'arrow-undo',
          'title': 'Finished Components and Layouts',
          'description': `Connect theme over directives and your fron-end is done`,
          'items': [
            {
              'backgroundImage': 'assets/imgs/background/11.jpg',
            },
            {
              'backgroundImage': 'assets/imgs/background/12.jpg',
            },
            {
              'backgroundImage': 'assets/imgs/background/7.jpg',
            }
          ]
        };
    }

    load(): Observable<any> {
        const that = this;
        that.loadingService.show();
        if (AppSettings.IS_FIREBASE_ENABLED) {
            return new Observable(observer => {
                this.af
                    .object('intro')
                    .valueChanges()
                    .subscribe(snapshot => {
                        that.loadingService.hide();
                        observer.next(snapshot);
                        observer.complete();
                    }, err => {
                        that.loadingService.hide();
                        observer.error([]);
                        observer.complete();
                    });
            });
        } else {
            return new Observable(observer => {
                that.loadingService.hide();
                observer.next(this.getData());
                observer.complete();
            });
        }
    }
}
